import React from 'react';
import logo from './../../LOGO-PRODUCTO-removebg-preview.png';

function Barnav({LoginVisibilityFunction, premiumVisibilityFunction ,currentVisibilityFunction ,freeVisibilityFunction, centralVisibilityFunction}) {
  
  
  return (
    <div className="barnav-container">
      <nav className="barnav">
        <div className='container-logo-barnav'>
          <img onClick={(e) => LoginVisibilityFunction(e)} className='logo' src={logo} />
        </div>
        <ul className="barnav-list">
        <li className="barnav-item">
            <a onClick={(e) => centralVisibilityFunction(e)}  className="barnav-link">Inicio</a>
          </li>
          
          <li className="barnav-item">
            <a onClick={(e) => freeVisibilityFunction(e)}  className="barnav-link">Basic Versión</a>
          </li>
          <li className="barnav-item">
            <a onClick={(e) => currentVisibilityFunction(e)}  className="barnav-link">Standart Versión</a>
          </li>
          <li className="barnav-item">
            <a   onClick={(e) => premiumVisibilityFunction(e)} className="barnav-link">Premium Versión</a>
          </li>
       
        </ul>
      </nav>
    </div>
  );
}

export default Barnav;
